import { Listbox } from '@headlessui/react';
import classNames from 'classnames';
import { useField } from 'formik';
import { useRouter } from 'next/router';
import { Fragment } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

type OptionsValues = 'CITIZENSHIP_CARD' | 'RESIDENCE_PERMIT' | 'EMPRESA';

const optionsES = {
  CITIZENSHIP_CARD: 'Cédula de ciudadanía',
  RESIDENCE_PERMIT: 'Cédula de extranjería',
  EMPRESA: 'NIT',
};

const optionsEN = {
  CITIZENSHIP_CARD: 'Citizenship card',
  RESIDENCE_PERMIT: 'Residence permit',
  EMPRESA: 'NIT',
};

const IdTypeSelect = ({ name }: { name: string }) => {
  const [field, , helper] = useField({ name });
  const router = useRouter();
  const language = router.locale as SupportedLanguages;
  const options = language === 'es' ? optionsES : optionsEN;

  return (
    <div className="relative flex flex-col gap-1 pb-6 pt-3 w-full">
      <label
        className={classNames(
          'absolute',
          'top-0',
          'left-4',
          'bg-white',
          'px-1',
          'text-philippine-silver',
          'z-10',
          'text-sm'
          // {
          //   "text-copper": focused,
          //   "text-philippine-silver": !focused,
          // }
        )}
      >
        Tipo de identificación
      </label>
      <div className="relative w-full">
        <Listbox
          value={field.value}
          name={name}
          onChange={(value) => {
            helper.setValue(value);
          }}
        >
          {({ open }) => (
            <>
              <Listbox.Button className="appearance-none border text-base rounded-md h-12 border-philippine-silver px-5 grow focus:border-copper flex justify-between items-center w-full outline-none">
                <div>{options[field.value as OptionsValues]}</div>
                {open ? (
                  <FiChevronUp className="text-philippine-silver" />
                ) : (
                  <FiChevronDown className="text-philippine-silver" />
                )}
              </Listbox.Button>
              <Listbox.Options className="max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm absolute top-16 left-0 z-20">
                {Object.entries(options).map(([value, label]) => (
                  <Listbox.Option key={value} value={value} as={Fragment}>
                    {({ active, selected }) => (
                      <li
                        className={classNames(
                          'h-14',
                          'px-5',
                          'flex',
                          'items-center',
                          'cursor-pointer',
                          {
                            'bg-copper bg-opacity-25 text-white': active,
                            'bg-white text-black': !active,
                          }
                        )}
                      >
                        {label}
                      </li>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </>
          )}
        </Listbox>
      </div>
    </div>
  );
};

export default IdTypeSelect;
